import Services from 'services/Services';
import { useEffect, useRef, useState } from 'react';
import { getOptionItems, OptionItem } from 'helpers/getOptionItems';
import { SiteTypePayload } from 'services/payloads/SiteTypePayload';
import { DiscountPayload } from 'services/interfaces/DiscountPayload';
import { RatePayload } from 'services/interfaces/RatePayload';
import { Session } from 'state/Session';

export class LookupOptions {
  parkId: string;
  siteTypes: SiteTypePayload[] = [];
  siteTypeOps: OptionItem[] = [];
  discounts: DiscountPayload[] = [];
  discountOps: OptionItem[] = [];
  rates: RatePayload[] = [];
  rateOps: OptionItem[] = [];
}

export function useLookups(): LookupOptions {
  const parkId = Session.parkId;
  const [lookups, setLookups] = useState<LookupOptions>(Session.lookups || new LookupOptions());
  const hasBeenLoaded = (parkId && lookups.parkId === parkId);
  const isLoading = useRef(false);

  const fetchData = async (parkId: string) => {
    if (isLoading.current) return;
    isLoading.current = true;

    const lookups = new LookupOptions();
    lookups.parkId = parkId;
    const allSiteTypes = Services.SiteTypes.getAll(parkId);
    const allDiscounts = Services.Discounts.getAll(parkId);
    const allRates = Services.Rates.getAll(parkId);
    const [
      siteTypes, discounts, rates
    ] = await Promise.all([
      allSiteTypes, allDiscounts, allRates
    ]);

    lookups.siteTypes = siteTypes;
    lookups.siteTypeOps = getOptionItems(siteTypes, x => x.name);
    lookups.discounts = discounts;
    lookups.discountOps = getOptionItems(discounts, x => x.name);
    lookups.rates = rates;
    lookups.rateOps = getOptionItems(rates, x => x.name);
    setLookups(lookups);
    Session.lookups = lookups;
    isLoading.current = false;
  }

  useEffect(() => {
    if (parkId && !hasBeenLoaded) fetchData(parkId);
  }, [parkId, hasBeenLoaded]);

  return lookups;
}
